export const PERMISSIONS = {
  FEED_CALCULATOR_CANVIEW: "FEED_CALCULATOR_CANVIEW",
  FARM_CALCULATOR_CANVIEW: "FARM_CALCULATOR_CANVIEW",
  USER_PROFILE_CANVIEW: "USER_PROFILE_CANVIEW",
  SAVE_MODAL_CANVIEW: "SAVE_MODAL_CANVIEW",
  ALLUSERLISTCANVIEW: "ALLUSERLISTCANVIEW",
  ADMIN_PANEL_CANVIEW: "ADMIN_PANEL_CANVIEW",
  MILLING_INFORMATION_CANVIEW: "MILLING_INFORMATION_CANVIEW",
};
